module.exports = __webpack_public_path__ + "img/exit_1.a2fedb0c.svg";